export default __webpack_public_path__ + "static/media/1.abfea5b6.webp";